module.exports = __webpack_public_path__ + "img/logo1 (18).cbe729b6.jpg";